import React from 'react';
import {ParallelsVideoInterface} from "../video__parallels/parallels";

const ParallelsOneVideo = ({id, name, video_url, create_date, category_id, category_name}: ParallelsVideoInterface) => {
    const [viewed, setViewed] = React.useState(false)
    const handleView = () => {
        if (!viewed) {
            setViewed(true)
                // @ts-ignore
                ym(100105951,'reachGoal','video-parallels')
        }
    }
    return (
            <div className="video-section" onClick={handleView}>
                <iframe
                    className='video'
                    src={video_url}
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                <p className='video-text'>{name}</p>
            </div>
    );
};

export default ParallelsOneVideo;